/* ------------------------------------------------------------
   Montrose — barre de défilement des carrousels (1er octobre 2026)

   Pour chaque piste horizontale marquée `data-mon-defile="Avis"` (le mot
   sert aux libellés des flèches : « Avis suivants »), pose juste après
   elle une barre toujours visible : un rail, un curseur qui suit le
   défilement, deux flèches sur ordinateur. Le rail se clique et se
   glisse. Quand tout tient à l'écran, la barre se masque.
   Styles : assets/mon-defile.css.
   ------------------------------------------------------------ */
(function () {
  if (window.monDefile) return;
  window.monDefile = true;

  var CHEVRON_PREV = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="m14.5 6.5-5.5 5.5 5.5 5.5"/></svg>';
  var CHEVRON_NEXT = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="m9.5 6.5 5.5 5.5-5.5 5.5"/></svg>';

  function monter(piste) {
    if (piste.monDefileActif) return;
    piste.monDefileActif = true;

    var nom = piste.dataset.monDefile || 'Éléments';
    var barre = document.createElement('div');
    barre.className = 'mon-defile';
    barre.innerHTML =
      '<button class="mon-defile__fleche" type="button" data-sens="-1" aria-label="' + nom + ' précédents">' + CHEVRON_PREV + '</button>' +
      '<div class="mon-defile__rail" aria-hidden="true"><span class="mon-defile__curseur"></span></div>' +
      '<button class="mon-defile__fleche" type="button" data-sens="1" aria-label="' + nom + ' suivants">' + CHEVRON_NEXT + '</button>';
    piste.insertAdjacentElement('afterend', barre);

    var rail = barre.querySelector('.mon-defile__rail');
    var curseur = barre.querySelector('.mon-defile__curseur');
    var prev = barre.querySelector('[data-sens="-1"]');
    var next = barre.querySelector('[data-sens="1"]');
    var part = 30; /* largeur du curseur, en % du rail */

    function maximum() {
      return Math.max(0, piste.scrollWidth - piste.clientWidth);
    }

    function majour() {
      var max = maximum();
      if (max <= 4) {
        barre.hidden = true;
        piste.dataset.monDefileEtat = 'fixe';
        return;
      }
      barre.hidden = false;
      var x = Math.min(max, Math.max(0, piste.scrollLeft));
      part = Math.max(12, (piste.clientWidth / piste.scrollWidth) * 100);
      curseur.style.width = part + '%';
      curseur.style.left = (x / max) * (100 - part) + '%';
      piste.dataset.monDefileEtat = x <= 2 ? 'debut' : x >= max - 2 ? 'fin' : 'milieu';
      prev.disabled = x <= 2;
      next.disabled = x >= max - 2;
    }

    var attente = false;
    function planifier() {
      if (attente) return;
      attente = true;
      requestAnimationFrame(function () {
        attente = false;
        majour();
      });
    }

    /* Un pas = l'écart entre deux cartes voisines. */
    function pas() {
      var cartes = piste.querySelectorAll('li');
      if (cartes.length > 1) return cartes[1].offsetLeft - cartes[0].offsetLeft;
      return piste.clientWidth * 0.8;
    }

    barre.addEventListener('click', function (event) {
      var fleche = event.target.closest('.mon-defile__fleche');
      if (!fleche) return;
      piste.scrollBy({
        left: Number(fleche.dataset.sens) * pas(),
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
    });

    /* Clic ou glissé sur le rail : le centre du curseur suit le pointeur.
       L'aimantation est suspendue le temps du geste, sinon la piste
       sauterait de carte en carte sous le doigt. */
    function suivre(event) {
      var cadre = rail.getBoundingClientRect();
      var course = cadre.width * (1 - part / 100);
      if (course <= 0) return;
      var position = (event.clientX - cadre.left - (cadre.width * part) / 200) / course;
      piste.scrollLeft = Math.min(1, Math.max(0, position)) * maximum();
    }

    function lacher(event) {
      if (!barre.classList.contains('mon-defile--prise')) return;
      barre.classList.remove('mon-defile--prise');
      piste.style.scrollSnapType = '';
      piste.style.scrollBehavior = '';
      if (rail.hasPointerCapture && rail.hasPointerCapture(event.pointerId)) rail.releasePointerCapture(event.pointerId);
    }

    rail.addEventListener('pointerdown', function (event) {
      if (event.button) return;
      event.preventDefault();
      barre.classList.add('mon-defile--prise');
      piste.style.scrollSnapType = 'none';
      piste.style.scrollBehavior = 'auto';
      if (rail.setPointerCapture) rail.setPointerCapture(event.pointerId);
      suivre(event);
    });
    rail.addEventListener('pointermove', function (event) {
      if (barre.classList.contains('mon-defile--prise')) suivre(event);
    });
    rail.addEventListener('pointerup', lacher);
    rail.addEventListener('pointercancel', lacher);

    piste.addEventListener('scroll', planifier, { passive: true });
    window.addEventListener('resize', planifier, { passive: true });
    window.addEventListener('load', planifier);
    if ('ResizeObserver' in window) {
      var veille = new ResizeObserver(planifier);
      veille.observe(piste);
      if (piste.firstElementChild) veille.observe(piste.firstElementChild);
    }
    majour();
  }

  function demarrer(racine) {
    (racine || document).querySelectorAll('[data-mon-defile]').forEach(monter);
  }
  /* 3 octobre 2026 : exposé pour les pistes ajoutées après coup
     (résultats de recherche « au plus proche », voir mon-recherche-proche.js). */
  window.monDefileDemarrer = demarrer;

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { demarrer(); });
  else demarrer();
  document.addEventListener('shopify:section:load', function (event) { demarrer(event.target); });
})();
